import React, { useState, useCallback, useRef } from 'react';
import { BiSidebar } from 'react-icons/bi';
import { IoMenu } from 'react-icons/io5';

import { DataState } from '../../context/DataProvider';
import Tabbar from '../base/Tabbar';
import ActivityIndicator from './ActivityIndicator';
import Sidebar from '../Sidebar';

const BaseLayout = ({
  leftSide,
  children,
  tabBarAbsolute = true,
  createName,
  chatHistory,
  selectedChatHistory,
  handleSelectChat,
  handleCreate,
  hideLeftHeader = false,
  tabName,
}) => {
  const {
    toggleSidebar: sidebarCollapsed,
    setToggleSidebar,
    rightSidebarWidth,
    setRightSidebarWidth,
  } = DataState();
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  const toggleSidebar = tabName === 'communication' ? true : sidebarCollapsed;

  // --- State and Refs for Resizable Sidebar ---
  const isResizing = useRef(false);
  const resizableContainerRef = useRef(null);
  const rightSidebarRef = useRef(null);
  const activeWidthRef = useRef(300);

  const handleMouseMove = useCallback((e) => {
    if (!isResizing.current || !resizableContainerRef.current) return;
    const containerRect = resizableContainerRef.current.getBoundingClientRect();
    const newWidth = containerRect.right - e.clientX;
    const minWidth = 250;
    const maxWidth = 550;

    if (newWidth >= minWidth && newWidth <= maxWidth) {
      activeWidthRef.current = newWidth;
      if (rightSidebarRef.current) {
        rightSidebarRef.current.style.width = `${newWidth}px`;
      }
    }
  }, []);

  const handleMouseUp = useCallback(() => {
    isResizing.current = false;
    document.removeEventListener('mousemove', handleMouseMove);
    document.removeEventListener('mouseup', handleMouseUp);
    setRightSidebarWidth(activeWidthRef.current);
  }, [handleMouseMove, setRightSidebarWidth]);

  const handleMouseDown = useCallback(
    (e) => {
      e.preventDefault();
      isResizing.current = true;
      activeWidthRef.current = rightSidebarWidth;
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    },
    [rightSidebarWidth, handleMouseMove, handleMouseUp],
  );

  return (
    <div className="bg-3 text-p-text relative flex h-screen max-h-[100svh] w-screen flex-col gap-2 overflow-hidden p-2 md:flex-row md:gap-2 md:p-2">
      {/* Desktop Sidebar */}
      <div
        className={`${
          toggleSidebar ? 'hidden md:block md:w-16' : 'hidden md:block md:w-56'
        } relative h-full flex-shrink-0 transform overflow-hidden rounded-xl border border-zinc-700 transition-all duration-150 md:rounded-2xl`}
      >
        <Sidebar
          toggleSidebar={toggleSidebar}
          isOpen={false}
          onToggle={() => setToggleSidebar(!toggleSidebar)}
          tabName={tabName}
        />
      </div>

      {/* Mobile Sidebar Overlay */}
      <div className="md:hidden">
        <Sidebar
          toggleSidebar={false}
          isOpen={mobileSidebarOpen}
          onToggle={() => setMobileSidebarOpen(!mobileSidebarOpen)}
          tabName={tabName}
        />
      </div>

      {/* Main Resizable Area */}
      <div ref={resizableContainerRef} className="flex h-full min-w-0 flex-1">
        {/* Main Content */}
        <div className="bg-1 relative flex h-full flex-1 flex-col gap-7 overflow-hidden rounded-2xl border border-zinc-700 p-2 sm:p-4">
          {tabName !== 'communication' && (
            <button
              className="absolute left-2 top-2 z-10 hidden rounded-lg p-1 text-lg transition-colors hover:bg-white hover:bg-opacity-10 md:block md:text-xl"
              onClick={() => setToggleSidebar(!toggleSidebar)}
            >
              <BiSidebar />
            </button>
          )}
          {/* Mobile Sidebar Toggle Button */}
          <button
            className="absolute left-2 top-2 z-30 text-2xl sm:hidden"
            onClick={() => {
              setMobileSidebarOpen(true);
            }}
          >
            <IoMenu />
          </button>
          <Tabbar absolute={tabBarAbsolute} />
          {children}
        </div>
        {leftSide && (
          <>
            {/* MODIFIED: Draggable Handle - This now defines the separation space */}
            {/* eslint-disable-next-line */}
            <div
              className="group hidden w-2 flex-shrink-0 cursor-col-resize items-center justify-center md:flex"
              onMouseDown={handleMouseDown}
            >
              <div className="h-12 w-0.5 rounded-full bg-zinc-700 transition-colors duration-200 group-hover:bg-[#5652CF]" />
            </div>

            <div
              ref={rightSidebarRef}
              className="hidden h-full overflow-hidden md:block"
              style={{ width: `${rightSidebarWidth}px` }}
            >
              <div className="bg-1 flex h-full flex-col rounded-xl border border-zinc-800 shadow-lg">
                {/* Header */}
                <div className="flex h-14 items-center justify-between border-b border-zinc-700 p-4">
                  <h1 className="text-sm font-bold tracking-wide text-zinc-200">
                    Workspace
                  </h1>
                  {/* {(
                <div className="px-3 py-1 rounded-full flex items-center gap-2 bg-blue-900/50 border border-blue-700/60">
                  <div className="bg-blue-400 h-2 w-2 rounded-full animate-pulse"></div>
                  <span className="text-xs font-medium text-blue-300">Running</span>
                </div>
              )} */}
                  <ActivityIndicator />
                </div>
                {/* Conditionally render the heading */}
                {/* {!hideLeftHeader && (
              <>
                <div className="flex items-center justify-between mb-3">
                  <h1 className="text-base font-bold ">Supermanager Workspace</h1>
                </div>
              </>
            )} */}

                {/* <div
              className={`flex flex-col gap-3 rounded-3xl flex-1 overflow-hidden ${hideLeftHeader ? "" : "bg-2"
                }`}
            > */}
                {/* {!hideLeftHeader && (
                <div className="flex items-center justify-between w-full br-1 border-b border-opacity-20 py-3 px-5">
                 
                  <div className="flex items-center gap-3 ">
                  <div className="bg-[#00A01C] h-3 w-3 rounded-full hover:scale-105"></div>
                  <span className="text-base">Planning</span>
                </div>
                </div>
              )} */}
                {leftSide}
                {/* </div> */}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
export default BaseLayout;
